import React from 'react';
import Select from 'react-select';
import {Option} from "../../types/formTypes";

interface MultiSelectInputProps {
    name: string;
    options: Option[];
    placeholder?: string;
    error?: boolean;
    required?: boolean;
    label?: string;
}

const MultiSelectInput: React.FC<MultiSelectInputProps> = ({
    name,
    options,
    placeholder,
    error = false,
    required = false,
    label
}) => {

    return (
        <div className="form-field">
            {label && <label className={required ? 'required-field' : ''}>{label}</label>}
            <Select
            isMulti
            name={name}
            options={options}
            className={`react-select-container ${error ? 'error-border' : ''}`}
            placeholder={placeholder}
        />
        </div>
    );
};

export default MultiSelectInput;